// extracted by mini-css-extract-plugin
module.exports = {"contact__subcontent":"Contact_contact__subcontent__1Lg2h"};